function compendiumFilter(link) {
  
  link.addEventListener('click', function(event) {

    event.preventDefault()
    
    let filter = link.dataset.filter,
        allLinks = document.querySelectorAll('.filter-item')
        items = document.querySelectorAll('.compendium-card')

    allLinks.forEach(filterLink => {
      if (filterLink.classList.contains('filter-active')) {
        filterLink.classList.remove('filter-active') 
      }
    })

    link.classList.toggle('filter-active')

    console.log(filter)

      items.forEach(item => {
        if (item.classList.contains(filter)) {
          item.classList.add('visible-card')
          item.style.order = -1
          item.style.opacity = 1
        } else {
          item.classList.remove('visible-card')  
          item.style.order = 0
          item.style.opacity = 0.3
        }
      });
        
  })

}

let filters = document.querySelectorAll('.filter-item')


filters.forEach(filter => {
  compendiumFilter(filter)
});



// window.addEventListener('load', (event) => {
//   compendium()
// });



// if (Shopify.designMode) {
//   document.addEventListener("shopify:section:load", function (event) {
//     compendium();
//   });
// }
